export default __webpack_public_path__ + "static/media/WhoEatsWhat_08.25d00754.png";